export default "__VITE_ASSET__B4dX1XTa__"